var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loaderr', {'leave': !_vm.active}]},[_c('img',{staticClass:"eye",attrs:{"src":"/loading.gif"}})])}
var staticRenderFns = []

export { render, staticRenderFns }